import { Controller } from "stimulus"

// #1616: bij Nederland het KvK-nummer, bij een ander land het
// registratienummer. De server rendert de juiste stand al; dit wisselt alleen
// als iemand het land verandert.
export default class extends Controller {
  static targets = ["land", "nederland", "buitenland"]
  static values = { nederland: String }

  wissel() {
    const nederland = this.landTarget.value === "" || this.landTarget.value === this.nederlandValue
    this.nederlandTargets.forEach((veld) => { veld.hidden = !nederland })
    this.buitenlandTargets.forEach((veld) => { veld.hidden = nederland })
  }
}
